import { render, staticRenderFns } from "./setName.vue?vue&type=template&id=1a435b27&scoped=true&"
import script from "./setName.vue?vue&type=script&lang=js&"
export * from "./setName.vue?vue&type=script&lang=js&"
import style0 from "./setName.vue?vue&type=style&index=0&id=1a435b27&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a435b27",
  null
  
)

export default component.exports